<template>
	<el-dialog :title="!dataForm.recNo ? '添加月报' : '修改月报'" :close-on-click-modal="false" :visible.sync="visible"
		width="600px">
		<el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="100px" class="border-form">
			<el-row class="set_border">
				<el-col :span="24" class="col-set_border">
					<el-form-item label="月报编号" prop="monthlyName" class="item">
						<el-input v-model="dataForm.monthlyName" placeholder="请输入" style="width: 400px;"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="set_border">
				<el-col :span="24" class="col-set_border">
					<el-form-item label="时间" prop="plannedTime" class="item">
						<el-date-picker v-model="timeArray" type="daterange" range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
							style="width: 400px;">
						</el-date-picker>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<el-row class="formBtnGroup">
			<el-button v-preventReClick class="btn" type="primary" size="small" @click="dataFormSubmit()">保存</el-button>
			<el-button v-preventReClick class="rebtn" size="small" @click="visible = false">取消</el-button>
		</el-row>
	</el-dialog>
</template>

<script>
import $common from "@/utils/common.js"
export default {
	name: "project-monthly-add-or-update",
	data() {
		return {
			visible: false,
			inline: false,
			action: '',
			timeArray: [],
			dataForm: {
				recNo: '',
				workNo: $common.getItem("workNo"),
				monthlyName: '',
				beginTime: '',
				endTime: '',
			},
			dataRule: {
				monthlyName: [
					{ required: true, message: " ", trigger: "change" }
				]
			},
		}
	},
	methods: {
		init(id) {
			this.timeArray = [];
			this.dataForm = {
				recNo: '',
				workNo: $common.getItem("workNo"),
				monthlyName: '',
				beginTime: '',
				endTime: '',
			};
			this.visible = true;
			this.dataForm.recNo = id ? id : '';
			this.$nextTick(() => {
				if (this.dataForm.recNo) {
					this.$http({
						url: this.$store.state.httpUrl + `/business/projectmonthlyreportinfo/info/${this.dataForm.recNo}`,
						method: 'get',
						params: {}
					}).then(({ data }) => {
						if (data && data.resultCode === 200) {
							this.dataForm = data.body
							this.timeArray = [this.dataForm.beginTime, this.dataForm.endTime];
						}
					})
				} else {
					// 新增
					this.getInitProjectMonthlyInfo()
				}
			});
			this.$refs['dataForm'].resetFields();
		},
		getInitProjectMonthlyInfo() {
			this.$http({
				url: this.$store.state.httpUrl + `/business/projectmonthlyreportinfo/initProjectMonthly`,
				method: "GET",
				params: this.$http.adornParams({
					workNo: $common.getItem("workNo"),
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$set(this.dataForm, "monthlyName", data.body.monthlyName);
				}
			});
		},
		// 表单提交
		dataFormSubmit() {
			this.dataForm.beginTime = this.timeArray[0];
			this.dataForm.endTime = this.timeArray[1];
			this.$refs["dataForm"].validate(valid => {
				if (valid) {
					let _url = "/business/projectmonthlyreportinfo/save";
					if (this.dataForm.recNo) {
						_url = "/business/projectmonthlyreportinfo/update";
					}
					this.$http({
						url: this.$store.state.httpUrl + _url,
						method: "post",
						data: this.$http.adornData(this.dataForm)
					}).then(({ data }) => {
						if (data && data.resultCode === 200) {
							this.$message({
								message: "操作成功",
								type: "success",
								duration: 1500,
								onClose: () => {
									this.visible = false;
									this.$parent.getDataList();
								}
							});
						}
					});
				}
			});
		},
	}
}
</script>
<style lang="scss" scoped="scoped">
.item::v-deep .el-form-item__label {
	color: #00428E !important;
	margin-right: 10px !important;
	font-weight: bold !important;
	background-color: #E1F1FF;
	white-space: nowrap !important;
	border-right: solid #dadada 1px;
}

.border-form .el-row.set_border {
	border-bottom: solid #dadada 1px;
	border-left: solid #dadada 1px;
	border-right: solid #dadada 1px;
}

.border-form .el-row.set_border:first-child {
	border-top: solid #dadada 1px;
}

::v-deep .el-form-item {
	//   display: flex !important;
	align-items: stretch !important;
	margin-bottom: 0px !important;
}
</style>
